var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.Field,
    {
      attrs: {
        label: _vm.label,
        disabled: _vm.disabled,
        "error-text": _vm.errorText,
      },
    },
    [
      _c(_setup.DropdownField, {
        attrs: {
          source: _setup.source,
          "text-field": "templateName",
          "value-field": "id",
          clearable: _vm.clearable,
          searchable: "",
          placeholder: _vm.placeholder,
        },
        model: {
          value: _setup.val,
          callback: function ($$v) {
            _setup.val = $$v
          },
          expression: "val",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }